import { number, object } from 'zod';

import { IS_REQUIRED, isGreaterThanOrEqualTo } from '@occc-app/lib/constants/validationMessages';

import { withIsEnabled } from '../utils/with-is-enabled';

const ProgressPerTransactionLimitEnabledSchema = object({
  limit: number({ required_error: IS_REQUIRED }).min(1, isGreaterThanOrEqualTo(1)),
});

const ProgressPerTransactionLimitDisabledSchema = object({
  limit: number().optional(),
});

export const ProgressPerTransactionLimitSchema = withIsEnabled(
  ProgressPerTransactionLimitEnabledSchema,
  ProgressPerTransactionLimitDisabledSchema,
);
